<div class="card">
  <div class="card-body">
    <div class="table-responsive table-card">
      <table class="table table-borderless table-centered align-middle table-nowrap mb-0">
        <thead class="text-muted table-light">
          <tr>
            <th scope="col">Company</th>
            <th scope="col">{{fieldAliasUsername}}</th>
            <th scope="col">ICCID</th>
            <th scope="col">Product</th>
            <th scope="col">Last Country</th>
            <th scope="col">Last Usage</th>
            <th scope="col" [class.text-center]="centreUsageMb">Usage (MB)</th>
            <th scope="col" [class.text-center]="centreCost">Cost</th>
            <th scope="col">Status</th>
            <th scope="col" *ngIf="showTag">Ref 1</th>
            <th scope="col" *ngIf="showTag2">Ref 2</th>
            <th scope="col" class="text-center align-middle">Manage</th>
            <th scope="col" class="text-center align-middle">Live View</th>
          </tr>
        </thead>
      
        @if(this.loading) {
          <div class="d-flex align-items-end justify-content-between mt-4 ms-4">
            <div>
              <p class="fw-medium text-muted text-truncate mb-4"><i>Loading...</i></p>
            </div>
          </div>
        }  
      
        <tbody>
          @for (data of userWithMostCost; track $index) {
            <tr>
              <td>
                <a
                  [ngbTooltip]="showTooltips ? 'View Company' : null"
                  onmouseover="this.style.cursor='pointer';"
                  placement="top"
                  tooltipClass="custom-tooltip-success"
                  (click)="companyClick(data.company)"
                >
                  <span [ngClass]="{ 'text-secondary': blueGridLinks }">{{data.company}}</span>
                </a>
              </td>
              <td>
                <a
                  [ngbTooltip]="showTooltips ? 'View ' + (fieldAliasUsername ? fieldAliasUsername : 'User') : null"
                  onmouseover="this.style.cursor='pointer';"
                  placement="top"
                  tooltipClass="custom-tooltip-success"
                  (click)="userClick(data.company, data.user)"
                >
                  <span [ngClass]="{ 'text-secondary': blueGridLinks }">@if(showFullnameAsUsername) {{{data.fullname}}} @else {{{data.user}}}</span>
                </a>
              </td>
              <td>
                <a
                  [ngbTooltip]="showTooltips ? 'Manage SIM' : null"
                  onmouseover="this.style.cursor='pointer';"
                  placement="top"
                  tooltipClass="custom-tooltip-success"
                  (click)="iccidClick(data.iccid)"
                  (mouseenter)="mouseEnter()"
                  (mouseleave)="mouseLeave()"
                >
                  <span [ngClass]="{ 'text-secondary': blueGridLinks }">{{data.iccid}}</span>
                </a>
              </td>
              <td>{{data.product}}</td>
              <td>
                <img
                width="16"
                [src]="data.lastCountryFlag"/>
                <span> {{data.lastCountry}}</span>
              </td>
              <td>{{data.lastUsage | date:'dd/MM/yyyy':'UTC'}}</td>
              <td [ngClass]="centreUsageMb ? 'text-center align-middle' : 'text-end'">
                {{data.usageGB}}
              </td>
              <td [ngClass]="centreCost ? 'text-center align-middle' : 'text-end'">
                <span class="text-success">{{data.costWithCurrencySymbol}}</span>
              </td>
              <td>
                @if (getSimStatus(data); as simStatus) {
                  @if (simStatus.iconClass != "") {
                    <i class="{{simStatus.iconClass}} {{simStatus.colourClass}} cell-icon align-middle me-1"></i>
                  }
                  <span class="align-middle">{{simStatus.statusDisplay}}</span>
                }
              </td>
              <td *ngIf="showTag">{{data.tag}}</td>
              <td *ngIf="showTag2">{{data.tag2}}</td>
              <td class="text-center align-middle">
                <a
                  onmouseover="this.style.cursor='pointer';"
                  [ngbTooltip]="showTooltips ? 'Manage' : null"
                  placement="top"
                  tooltipClass="custom-tooltip-success"
                  (click)="iccidClick(data.iccid)"
                  (mouseenter)="mouseEnter()"
                  (mouseleave)="mouseLeave()"
                >
                  <span [ngClass]="{ 'text-secondary': blueGridLinks }">Manage</span>
                </a>
              </td>
              <td class="text-center align-middle">
                <a
                  onmouseover="this.style.cursor='pointer';"
                  [ngbTooltip]="showTooltips ? 'Live View' : null"
                  placement="top"
                  tooltipClass="custom-tooltip-success"
                  (click)="viewTimeline(data.iccid)"
                  (mouseenter)="mouseEnter()"
                  (mouseleave)="mouseLeave()"
                >
                  <span [ngClass]="{ 'text-secondary': blueGridLinks }">View</span>
                </a>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>

<app-manage-esim-modal-form #manageEsimModalForm
  (eSimManagerFormCancelled)="manageEsimFormHasBeenCancelled()"
  (orderDataHasBeenSaved)="orderDataHasBeenSaved()"
  (orderStatusHasBeenUpdated)="orderStatusHasBeenUpdated()"
></app-manage-esim-modal-form>

<app-company-modal-form #companyModalForm
  (companyFormCancelled)="companyFormHasBeenCancelled()"
  (iccidClicked)="iccidClick($event)"
  (sureSimCompanyDataHasBeenSaved)="companyDataHasBeenSaved($event)"
></app-company-modal-form>

<app-timeline-esim-modal-form #timelineModalForm
></app-timeline-esim-modal-form>

<app-user-modal-form #userModalForm
  (sureSimUserDataHasBeenSaved)="userDataHasBeenSaved($event)"
  (userFormCancelled)="userFormHasBeenCancelled()"
></app-user-modal-form>
